var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        { staticClass: "content animate-panel" },
        [
          _c(
            "div",
            { staticClass: "hpanel" },
            [
              _c("search"),
              _vm._v(" "),
              _c("router-view", {
                on: { openUpgradePlanModal: _vm.openUpgradePlanModal }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isShowUpgradePlanModal
            ? _c("upgrade-plan-modal", {
                on: { close: _vm.closeUpgradePlanModal }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1d5a294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1d5a294","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/Video.vue
// module id = null
// module chunks = 